export default __webpack_public_path__ + "static/media/widget-settings-go-to-advanced-settings-button-image.c8cbce50.svg";